import { buildLinkLayer } from "./buildLayer.js";

/**
 * Request Submission.
 */

export const buildRequestLayer = buildLinkLayer();